// /src/toolkitServices/purchaseApi.js
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const purchaseApi = createApi({
  reducerPath: "purchaseApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_BASE_URL, // e.g. http://localhost:4000/api
    credentials: "include",
  }),
  tagTypes: ["Purchase"],
  endpoints: (builder) => ({
    // CREATE  POST /api/purchases
    addPurchase: builder.mutation({
      query: (payload) => ({
        url: "/purchases",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Purchase"],
    }),

    // LIST    GET /api/purchases?page=&limit=&q=&vendor=&dateFrom=&dateTo=
    getAllPurchases: builder.query({
      query: ({
        page = 1,
        limit = 20,
        search = "",
        vendor,        // vendor id (ObjectId string)
        dateFrom,      // ISO string YYYY-MM-DD
        dateTo,        // ISO string YYYY-MM-DD
      } = {}) => {
        const params = { page, limit, q: search };
        if (vendor)   params.vendor   = vendor;
        if (dateFrom) params.dateFrom = dateFrom;
        if (dateTo)   params.dateTo   = dateTo;
        return { url: "/purchases", params };
      },
      providesTags: ["Purchase"],
    }),

    // GET ONE GET /api/purchases/:id
    getPurchaseById: builder.query({
      query: (id) => `/purchases/${id}`,
      providesTags: (_res, _err, id) => [{ type: "Purchase", id }],
    }),

    // UPDATE  PUT /api/purchases/:id
    updatePurchase: builder.mutation({
      query: ({ id, ...patch }) => ({
        url: `/purchases/${id}`,
        method: "PUT",
        body: patch,
      }),
      invalidatesTags: (_res, _err, { id }) => [{ type: "Purchase", id }, "Purchase"],
    }),

    // DELETE  DELETE /api/purchases/:id
    deletePurchase: builder.mutation({
      query: (id) => ({
        url: `/purchases/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Purchase"],
    }),

    // BULK DELETE  POST /api/purchases/bulk/delete  { ids: [...] }
    bulkDeletePurchases: builder.mutation({
      query: (ids) => ({
        url: "/purchases/bulk/delete",
        method: "POST",
        body: { ids },
      }),
      invalidatesTags: ["Purchase"],
    }),
  }),
});

export const {
  useAddPurchaseMutation,
  useGetAllPurchasesQuery,
  useGetPurchaseByIdQuery,
  useUpdatePurchaseMutation,
  useDeletePurchaseMutation,
  useBulkDeletePurchasesMutation,
} = purchaseApi;

export default purchaseApi;
